//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required, numeric, decimal, minLength, maxLength, minValue, maxValue, helpers } from "vuelidate/lib/validators";
import ValidateResult from "@/library/ValidateResult";
import config from "@/config";
import errorTags from "@/ErrorTags";

const containDecimal = helpers.regex("containDecimal", /^\d*\.?\d+$/);

export default {
  components: {
		ValidateResult
	},
	props: {
		paraDialogAdd: {
      type: Boolean
		}
	},
  data: function() {
    return {
			txtRedNumber: "",
			txtPool: "0",
			chkBox: false,

			blnDense: true,
			blnLoading: false,
      blnRedNumberAutoFocus: true,

			blnShowMessage: false,
      strBannerClass: "",
      strBannerMessage: "",

      jsonResponse: {
        success: true,
        status: ""
      }
    };
  },
  validations: {
		txtRedNumber: {
      required,
      numeric,
      minLength: minLength(3),
      maxLength: maxLength(4)
		},
		txtPool: {
      required,
			decimal,
			containDecimal,
			minValue: minValue(0.00)
			// maxValue: maxValue(10000000.00)
    }
	},
  methods: {
    fcReset: function() {
			this.txtRedNumber = "",
			this.txtPool = "0",
			this.chkBox = false,

      this.blnShowMessage = false,
      this.strBannerClass = "",
      this.strBannerMessage = "",

			this.fcCheckBox();

			this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    fcCheckBox () {
			if (this.chkBox){
				this.chkBox = true;
			} else {
				this.chkBox = false;
			}
		},
    fcCancel () {
			this.$emit("cancel");
			this.fcReset();
		},
    fcAdd () {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let apiURL = config.defaultNumberAdd_Url();

				var jsonRequest = {
					session_token: this.$store.getters.sessionToken,
					user_id: this.$store.getters.username,
					red_num: this.txtRedNumber,
					pool: this.txtPool,
					box: this.chkBox,
				};

				// console.log(jsonRequest);

				this.blnLoading = true;
        this.jsonResponse.success = true;

        this.$http.post(apiURL, jsonRequest).then(
          function(apiResponse) {
						// Json Response Success
						// console.log(apiResponse);

						this.blnLoading = false;

            try {
              if (apiResponse) {
                if (typeof apiResponse.data.status == "string") {
                  this.jsonResponse.success = apiResponse.data.status == "1";
                } else {
                  this.jsonResponse.success = apiResponse.data.status == 1;
								}

								this.jsonResponse.status = apiResponse.data.statusdesc;

                if (this.jsonResponse.success == true) {
									this.$emit("success", this.txtRedNumber, this.txtPool, this.chkBox);
									this.fcReset();

									this.blnShowMessage = true;
									this.strBannerClass = "cssBannerSuccess";
									this.strBannerMessage = this.$t("ui.combine.add_default_number") + " - " + this.$t("message.success");
									setTimeout(() => this.blnShowMessage = false, 10000);
                } else {
									if (apiResponse.data.status == 500){
										this.jsonResponse.status = "SystemError";
									} else if (apiResponse.data.status == 501) {
										this.jsonResponse.status = "RedNumberExists";
									}

	                let blnCommonResult = this.$helpers.handleFeedback(this.jsonResponse.status);
									if (!blnCommonResult) {
										this.$emit("fail", "add_default_number", this.jsonResponse.status);
									}

                  // this.blnShowMessage = true;
                  // this.strBannerClass = "cssBannerError";
                  // this.strBannerMessage = this.jsonResponse.status;

									// if (this.jsonResponse.status == "invalidToken"){
									// 	this.$helpers.handleFeedback(this.jsonResponse.status);
									// }
                }
              }
            } catch (error) {
              this.jsonResponse.success = false;
              this.jsonResponse.status = errorTags.request.failed;
            }
          },
          function(apiResponse) {
						// Json Response Error
            this.blnLoading = false;
            this.jsonResponse.success = false;
            this.jsonResponse.status = errorTags.request.failed;
          }
        );
      }
		}
	}
};
